import {
  Slider as SliderCore,
  SliderBtn,
  SliderDots,
  SliderDrag,
  SliderItem,
  SliderCount,
} from '@studiometa/ui';

/**
 *  component
 */
export default class Slider extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderBtn,
      SliderDots,
      SliderCount,
    },
  };

  /**
   * get the first image of the Slider
   * @returns {string}
   */
  get firstImage() {
    return this.$el.querySelector('img').src ?? '';
  }
}
